import React from "react";
import Navigation from "./navigation";


import "../compoents/css/services.css";

function service() {
    return (
        <>



            <div id="service" >
                <div className="section5">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="title-block">
                                    <h3>Service We Offer</h3>
                                    <h4>Our department  special service </h4>

                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fa-solid fa-truck-medical"></i>
                                </div>
                                <div className="service-text">
                                    <h4>Emergency Care</h4>

                                    <p>We offer the best ambulance service.Three fully equipped Tempo-Travelers advanced trauma & cardiac life support (BLS/ATLS/ACLS) ambulances </p>

                                </div>
                            </div>

                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fa-solid fa-stethoscope"></i>
                                </div>
                                <div className="service-text">
                                    <h4>Call Center 24/7</h4>

                                    <p>24x7 qualified medical professionals are available all the time including nursing and support service staff.</p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fas fa-microscope"></i>
                                </div>
                                <div className="service-text">
                                    <h4>24/7 Pharmacy</h4>

                                    <p>There are 2 exclusive IP pharmacies – one that is open for 24 hours on Ground Floor for OP/IP & the other open for 8 hours a day in the first floor. Five counters are available in our pharmacy and one counter is prioritised for emergency and ICU’s.
                                    </p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fas fa-burn"></i>
                                </div>
                                <div className="service-text">
                                    <h4> Blood Test</h4>

                                    <p>Our Department of Transfusion Medicine & Blood Bank provides 24x7 facility with blood component therapy, Apheresis, and Immunohematology laboratory diagnostics.</p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fa fa-heartbeat" aria-hidden="true"></i>
                                </div>
                                <div className="service-text">
                                    <h4> Cardiac Surgery</h4>


                                    <p>The department of cardiology stated its services in 2006 with outpatient services and has rapidly improved its infrastructure and capabilities. Apart from dedicated Cardiac Cathlab and Cardiac ICU, the cardiology ward houses 20 inpatient teaching beds as well. Bed side ECHO has been the norm since 2009.</p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fas fa-tooth"></i>
                                </div>
                                <div className="service-text">
                                    <h4> Dental Care</h4>

                                    <p>Lorem Ipsum is simply dummy text of
                                        the
                                        printing and typesetting industry. Lorem Ipsum
                                        has
                                        been the industry's standard dummy text ever</p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fa-solid fa-user-doctor"></i>
                                </div>
                                <div className="service-text">
                                    <h4> Outdoor Checkup</h4>


                                    <p>Lorem Ipsum is simply dummy text of
                                        the
                                        printing and typesetting industry. Lorem Ipsum
                                        has
                                        been the industry's standard dummy text ever</p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fa-solid fa-eye"></i>
                                </div>
                                <div className="service-text">
                                    <h4>Ophthalmology</h4>
                                    <p>Ophthalmologists treat eye-related problems after the diagnosis with oral medication, cryotherapy, chemotherapy, and surgery. The surgeries are handled by specific subspecialist ophthalmologists only.</p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-4">
                                <div className="service-icon">
                                    <i className="fa-solid fa-heart-circle-bolt"></i>
                                </div>
                                <div className="service-text">
                                    <h4> Heart disease</h4>

                                    <p>We have vast experience in the most complicated coronary artery bypass surgery, surgery for all types of valvular heart diseases, paediatric heart surgery, adult and paediatric heart transplantation with success rates comparable to international standards.

                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}

export default service;